// Library Imports
import React, { useContext } from 'react'
import { Container, Button } from 'react-bootstrap'
import * as GiIcons from 'react-icons/gi'
import * as BsIcons from 'react-icons/bs'
import * as VscIcons from 'react-icons/vsc'
import * as MdIcons from 'react-icons/md'
import * as ImIcons from 'react-icons/im'

// Context Imports
import { DirectoryContext } from '../../contexts/DirectoryContext'
import { ListContext } from '../../contexts/ListContext'

// Asset Imports
import '../../assets/css/stylesheets/components/filter/CategoryFilter.css'

function CategoryFilter() {

    const iconOptions = [
        <GiIcons.GiBarn />,
        <BsIcons.BsGear />,
        <VscIcons.VscOrganization />,
        <MdIcons.MdOutlineSchool />,
        <GiIcons.GiDirectorChair />,
        <ImIcons.ImUserTie />
    ]

    const {
        categoryOptions,
    } = useContext(DirectoryContext);

    const {
        category,
        setCategory,
    } = useContext(ListContext);

    const handleCategoryChanged = (e) => {
        setCategory(e.target.value)
    }

    function getActiveCategoryClass(selectedCategoryID) {
        var buttonClass = '';
        if (category == selectedCategoryID) {
            buttonClass = 'categoryfilter-button-selected'
        }
        else {
            buttonClass = 'categoryfilter-button'
        }

        return buttonClass
    }

    return (
        <Container className='categoryfilter'>
            <h4 className='categoryfilter-header'>Top Categories</h4>
            <div className='categoryfilter-seperator'></div>
            <ul className='categoryfilter-list'>
                {
                    categoryOptions?.map((category, index) => {
                        return (
                            <li>
                                <Button
                                    value={category.ID}
                                    onClick={handleCategoryChanged}
                                    key={index}
                                    className={getActiveCategoryClass(category.ID)}>
                                    {iconOptions[index]}
                                    {category.Name} {/*({category.categoryListings?.length})*/}
                                </Button>
                            </li>
                        )
                    })
                }
            </ul>
        </Container>
    )
}

export default CategoryFilter